var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datacollection.labels.length > 0)?_c('div',{attrs:{"id":"doughnut-chart"}},[_c('el-row',[_c('div',{staticClass:"small"},[_c('doughnut',{attrs:{"max-fatias":_vm.maximoDeFatias,"chart-data":_vm.datacollection,"options":_vm.optionsGrafico}})],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }